import 'core-js/stable'
import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from '@assets/icons/icons.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import fontAwesomeIcon from '@assets/icons/icons-awesome'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import SimpleLineIcons from 'vue-simple-line'

import { i18n } from '@plugins/i18n'
import '@plugins/vee-validate'
import '@plugins/charts'

import App from './app.vue'

// Globally register all `_base`-prefixed components
import '@components/_globals'

// Add fontAwesome icon
library.add({ ...fontAwesomeIcon })
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('simple-line-icons', SimpleLineIcons)

// install coreui
Vue.use(CoreuiVue)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  icons,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
